import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../contexts/AuthContext";
import { useLanguage } from "../../contexts/LanguageContext";

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useLanguage();

  const { login, error, clearError, isLoading } = useAuthContext();

  // Limpiar error cuando el usuario empiece a escribir
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        clearError();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      return;
    }

    setIsSubmitting(true);
    try {
      await login({ email, password });
      // El redireccionamiento o actualización de UI se maneja en el contexto
    } catch (err) {
      // El error ya está manejado en el contexto
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <i className="fas fa-spinner fa-spin"></i>
        <p>{t("common", "AuthSidebar.loading")}</p>
      </div>
    );
  }

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="email">
          <i className="fas fa-user"></i> {t("common", "AuthSidebar.email")}
        </label>
        <input
          type="text"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("common", "AuthSidebar.emailPlaceholder")}
          required
          disabled={isSubmitting}
        />
      </div>

      <div className="form-group">
        <label htmlFor="password">
          <i className="fas fa-lock"></i> {t("common", "AuthSidebar.password")}
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t("common", "AuthSidebar.passwordPlaceholder")}
          required
          disabled={isSubmitting}
        />
      </div>

      <button
        type="submit"
        className="login-btn-form"
        disabled={isSubmitting || !email || !password}
      >
        {isSubmitting ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>{" "}
            {t("common", "AuthSidebar.loggingIn")}
          </>
        ) : (
          t("common", "buttons.login")
        )}
      </button>

      {error && (
        <div className="alert-message error" style={{ display: "flex" }}>
          <i className="fas fa-exclamation-circle"></i>
          <span>{error}</span>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <a href="#" style={{ color: "#d1c4e9", fontSize: "0.9rem" }}>
          {t("common", "buttons.forgotPassword")}
        </a>
      </div>
    </form>
  );
};

export default LoginForm;
